import { z } from 'zod';
export const placeId = z.string().min(1).max(120).regex(/^[A-Za-z0-9_-]+$/);
export const autocompleteInput = z.strictObject({ query: z.string().trim().min(3).max(200), session_token: z.uuid() });
export const detailsInput = z.strictObject({ place_id: placeId, session_token: z.uuid() });
export const suggestion = z.object({ place_id: placeId, name: z.string().max(400), address: z.string().max(1000) });
export const suggestions = z.array(suggestion).max(5);
export const preview = z.object({
  id: placeId, formattedAddress: z.string().max(1000),
  location: z.object({ latitude: z.number().min(-90).max(90), longitude: z.number().min(-180).max(180) }),
  addressComponents: z.array(z.object({ longText: z.string(), shortText: z.string().optional(), types: z.array(z.string()), languageCode: z.string().optional() })).max(30),
});
export const pickerStatusSchema = z.object({ enabled: z.boolean(), reason: z.string(), cap_micros: z.number(), spent_micros: z.number(), estimates: z.object({ autocomplete: z.number(), details: z.number() }) });
export type Suggestion = z.infer<typeof suggestion>;
export type Preview = z.infer<typeof preview>;
